import InputCheckbox from "./inputs/InputCheckbox.js";
import InputDate from "./inputs/InputDate.js";
import InputEmail from "./inputs/InputEmail.js";
import InputNumber from "./inputs/InputNumber.js";
import InputRadio from "./inputs/InputRadio.js";
import InputSelect from "./inputs/InputSelect.js";
import InputText from "./inputs/InputText.js";

export default class Form {
    constructor({ form, onSubmit, onFormReady }) {
        for (const [key, value] of Object.entries(arguments[0]))
            this[`_${key}`] = value;

        this._inputs = [];
        this._inputsCounter = 0;
        this._data = {};
        this._initialData = {};
        this._errors = [];
        this._inputTypes = {
            Checkbox: InputCheckbox,
            Date: InputDate,
            Email: InputEmail,
            Number: InputNumber,
            Radio: InputRadio,
            Select: InputSelect,
            Text: InputText
        };

        this.loadInputs();
    }

    init() {
        this._inputs.forEach((input) => input.init());
        this._form?.addEventListener("submit", this._onSubmit.bind(this, this));
    }

    loadInputs() {
        const containers = this._form.querySelectorAll(".input");
        this._inputs = Array.from({ length: containers.length });

        containers?.forEach((container, i) => {
            const type = container?.dataset?.type;
            const _input = [
                container.querySelector("input"),
                container.querySelector("textarea"),
                container.querySelector("select"),
            ]?.find((input) => input);
            const label = container.querySelector(".input-label");
            const error = container.querySelector(".input-error");
            const Class = this._inputTypes[type];
            const input = new Class({
                container,
                input: _input,
                label,
                error
            });
            input.cbackControls = this.handleInputControls.bind(this);
            input.dispatcher = this.inputDispatcher.bind(this);

            this._inputs.splice(i, 1, input);

            if (i === containers.length - 1)
                this._onFormReady(this);
        });
    }

    handleInputControls(targets, origin = null) {
        targets.forEach((target) => {
            const { name, actions } = target;
            const input = this._inputs.find((input) => input.name === name);

            if (!input) return;                        

            actions.forEach((action) => {
                let [verb, attribute] = action.split("-");
                let _value = null;

                if (verb === "set" && attribute.includes("=")) {
                    [attribute, _value] = attribute.split("=");

                    if (_value === "current") 
                        _value = origin?.value;

                    if (input[attribute] === _value) 
                        return;

                    input[attribute] = _value;

                    return;
                }

                if (verb === "set") {
                    input[attribute] = true;

                } else if (verb === "rmv") {
                    input[attribute] = false;

                } else if (verb === "do") {
                    input[attribute]();
                }
            });
        });
    }

    inputDispatcher(input) {
        // console.log(input);
        this._dispatcher?.(this);
    }

    reset() {
        this._inputs.forEach(input => input.reset());
    }

    get inputs() {
        return this._inputs;
    }

    get data() {
        this._inputs.forEach(
            (input) => this._data[input.name] = input.value
        );

        return this._data;
    }

    get errors() {
        return this._inputs
            .filter((input) => input.valid.flag === false)
            .map((input) => {
                input.toggleValidation();

                return {
                    name: input.name,
                    msg: input.valid.msg
                }
            });
    }

    get el() {
        return this._form;
    }

    get dispatcher() {
        return this._dispatcher;
    }

    set dispatcher(func) {
        this._dispatcher = func;
    }
}